// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { BatchProcessesQueries } from '../../../../types/server/modules/batchProcesses/queries';

export type * from '../../../../types/server/modules/batchProcesses/queries';

export const createQueries = ( requests: Requests ): BatchProcessesQueries => ({
  BatchProcessesProgress: ( params?, headers? ) => {
        return requests.get( `/batch-processes/progress/:batchProcessId?`, params, headers );
      },
  BatchProcessesProgressCount: ( params?, headers? ) => {
        return requests.get( `/batch-processes/progress-count/:batchProcessId`, params, headers );
      },
  BatchProcessesById: ( id, query, headers ) => { 
          return requests.get( `/batch-processes/${id}`, query, headers ); 
        },
  BatchProcesses: ( params?, headers? ) => {
        return requests.get( `/batch-processes/:id?`, params, headers );
      }
});
